import { render } from "./ShopIcon.vue?vue&type=template&id=687b25cf"
import script from "./ShopIcon.vue?vue&type=script&lang=js"
export * from "./ShopIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__